import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { CaretDownIcon } from '@radix-ui/react-icons';
import { Button, DropdownMenu } from '@radix-ui/themes';
import { CircleIcon, PolygonIcon, RectangleIcon, TriangleIcon } from '@phosphor-icons/react';
import { useTranslation } from '../../../i18n';
import { useEditorStore } from '../../../stores/editorStore';
const TOOLS = [
    { id: 'rectangle', titleKey: 'toolbar.tools.rectangle', icon: RectangleIcon },
    { id: 'circle', titleKey: 'toolbar.tools.circle', icon: CircleIcon },
    { id: 'triangle', titleKey: 'toolbar.tools.triangle', icon: TriangleIcon },
    { id: 'polygon', titleKey: 'toolbar.tools.polygon', icon: PolygonIcon },
];
export function ShapeTools() {
    const { t } = useTranslation();
    const { currentTool, setTool } = useEditorStore();
    const activeTool = TOOLS.find((tool) => tool.id === currentTool);
    const isShapeActive = TOOLS.some((tool) => tool.id === currentTool);
    const TriggerIcon = activeTool?.icon ?? RectangleIcon;
    return (_jsx("div", { className: "shape-tools", children: _jsxs(DropdownMenu.Root, { children: [_jsx(DropdownMenu.Trigger, { children: _jsxs(Button, { variant: "soft", radius: "none", size: "3", className: `shape-tools-trigger ${isShapeActive ? 'active' : ''}`, "aria-label": t('toolbar.shapes'), children: [_jsx(TriggerIcon, { "aria-hidden": "true", weight: isShapeActive ? 'fill' : 'regular' }), _jsx(CaretDownIcon, { "aria-hidden": "true", className: "shape-tools-chevron" })] }) }), _jsx(DropdownMenu.Content, { variant: "soft", size: "2", align: "start", sideOffset: 4, children: TOOLS.map((tool) => {
                        const Icon = tool.icon;
                        const isActive = currentTool === tool.id;
                        return (_jsxs(DropdownMenu.Item, { onSelect: () => setTool(tool.id), className: isActive ? 'shape-tools-item-active' : undefined, children: [_jsx(Icon, { "aria-hidden": "true", weight: isActive ? 'fill' : 'regular' }), t(tool.titleKey)] }, tool.id));
                    }) })] }) }));
}
